<template>
    <div>
        <p v-if="getInitData1 && (ltype=='1')">{{initData()}}</p>
        <p v-if="getInitData2 && (ltype=='2')">{{initData()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        <v-flex xs12>

            <quill-editor @blur="saveData" v-model='mycontent' :options="getEditorOption()">
            </quill-editor>
        </v-flex>
        <v-flex xs12 justify-end>
            <v-btn @click="showHTML">Show HTML</v-btn>
            <v-btn v-if="showedHTML" @click="updateHTML">Update</v-btn>
        </v-flex>
        <v-textarea v-if="showedHTML" v-model=HTMLcontent>
        </v-textarea>
        
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
/*import { ImageDrop } from 'quill-image-drop-module'
import imageResize from 'quill-image-resize-module'

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
-*/
export default {
    data() {
        return {
                editorOption: {
                    modules: {
                        toolbar: '#toolbar',
               /*         syntax: {
                            highlight: text => hljs.highlightAuto(text).value
                        },
                 */       imageDrop: true,
                        imageResize: true
                    },
                        theme: 'snow'
                },
                showedHTML : false,
                mycontent: '',
                HTMLcontent: '',
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getContent1',
                            'getInitData1',
                            'getInitData2',
                        ])
    ,
    components: {
        quillEditor: quillEditor
    },
    methods: {
        showHTML() {
            this.showedHTML = !this.showedHTML
            this.HTMLcontent = this.mycontent
        },
        updateHTML() {
            this.mycontent = this.HTMLcontent
            this.saveData()
        },
        saveData() {
            if (this.ltype == '1') {
                this.saveActualContent(this.getLanguagePrimary)
            } else {
                this.saveActualContent(this.getLanguageSecondary)
            }
        },
        saveActualContent(mylang) {   
            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent1', data)            
        },
        refreshData() {
            var lang = null
            if (this.ltype =='1') {
                if (this.getLanguagePrimaryTmp)
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                lang = this.getLanguagePrimary
                this.$store.commit('setRefresh1',false)
            } else {
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                lang = this.getLanguageSecondary
                this.$store.commit('setRefresh2',false)
            }            
            this.mycontent = this.getContentFromStore(lang.id)
        },
        getContentFromStore(lang_id) {
            return this.getContent1(lang_id)
        },
        initData(){
            var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setInitData1',false)
                lang = this.getLanguagePrimary
            } else {
                this.$store.commit('setInitData2',false)
                lang = this.getLanguageSecondary
            }
            this.mycontent = this.getContentFromStore(lang.id)
        },
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
                    /*syntax: {
                    highlight: text => hljs.highlightAuto(text).value
                    },
                    */imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        }
    }, 
    mounted() {
        this.initData()
    }


}
</script>

<style>

</style>


